import { useState } from "react";
import { GripVertical, Umbrella, Truck, Wrench, Package } from "lucide-react";

const ICON = { mezzo: Truck, mezzo_cantiere: Wrench, attrezzatura: Package };
const CHIP = {
  interno: "bg-white border-slate-200 text-slate-900",
  esterno: "bg-orange-50 border-orange-200 text-orange-900",
  mezzo: "bg-blue-50 border-blue-200 text-blue-900",
  mezzo_cantiere: "bg-emerald-50 border-emerald-200 text-emerald-900",
  attrezzatura: "bg-emerald-50/60 border-emerald-100 text-emerald-900",
};

export const dragPayload = (item) => JSON.stringify({ tipo: item.tipo, id: item.id });

// Iter 106: tessera trascinabile della lavagna (persona / mezzo / attrezzatura)
export function ResourceChip({ item, canDrag, compact }) {
  const r = item.r || {};
  const Icon = ICON[item.tipo];
  const tags = [];
  if (item.tipo === "interno" || item.tipo === "esterno") {
    if (r.qualifiche?.length) tags.push(r.qualifiche.join("/"));
    if (r.patente === false) tags.push("SP");
    if (item.tipo === "esterno" && (r.ditta || r.tipo)) tags.push(r.ditta || r.tipo);
    if (r.contratto_scadenza) tags.push(`t.det. ${r.contratto_scadenza.slice(8, 10)}/${r.contratto_scadenza.slice(5, 7)}`);
  } else if (item.tipo === "mezzo_cantiere" && r.proprieta === "noleggio") tags.push(`noleggio ${r.fornitore || ""}`.trim());
  return (
    <div
      draggable={canDrag}
      onDragStart={(e) => { e.dataTransfer.setData("text/plain", dragPayload(item)); e.dataTransfer.effectAllowed = "move"; }}
      className={`group flex items-start gap-1.5 rounded-md border px-2 py-1 text-xs leading-tight ${CHIP[item.tipo]} ${canDrag ? "cursor-grab active:cursor-grabbing hover:shadow-sm" : ""}`}
      data-testid={`chip-${item.tipo}-${item.id}`}
      title={item.label}
    >
      {canDrag && <GripVertical className="h-3.5 w-3.5 mt-0.5 shrink-0 text-slate-300 group-hover:text-slate-500" />}
      {Icon && <Icon className="h-3.5 w-3.5 mt-0.5 shrink-0 opacity-70" />}
      <div className="min-w-0">
        <div className={`truncate ${item.tipo === "interno" && r.qualifiche?.includes("PRE") ? "font-bold" : "font-semibold"}`}>{item.label}</div>
        {!compact && tags.length > 0 && <div className="text-[10px] opacity-70 truncate">{tags.join(" · ")}</div>}
        {item.assenza && (
          <div className="text-[10px] text-red-700 font-semibold flex items-center gap-1">
            <Umbrella className="h-3 w-3" /> {item.assenza.tipo} dal {item.assenza.dal.slice(8, 10)}/{item.assenza.dal.slice(5, 7)}{item.assenza.al ? ` al ${item.assenza.al.slice(8, 10)}/${item.assenza.al.slice(5, 7)}` : " (da definire)"}
          </div>
        )}
      </div>
    </div>
  );
}

// Zona di rilascio (colonna sede o blocco speciale)
export function DropZone({ onDrop, canDrop, className, children, testId }) {
  const [over, setOver] = useState(false);
  return (
    <div
      onDragOver={(e) => { if (canDrop) { e.preventDefault(); setOver(true); } }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => {
        setOver(false);
        if (!canDrop) return;
        e.preventDefault();
        try { onDrop(JSON.parse(e.dataTransfer.getData("text/plain"))); } catch (_) { /* ignore */ }
      }}
      className={`${className} ${over ? "ring-2 ring-[#0044FF] ring-offset-1 bg-blue-50/40" : ""} transition`}
      data-testid={testId}
    >
      {children}
    </div>
  );
}
